import { isListingAvailable } from '@paction-2.0/util/listings/availability';

export type ListingAvailabilityStatus = {
  label: 'Reserved' | 'Ready for rehoming' | 'Coming soon';
  variant: 'green' | 'blue' | 'grey';
};

export type ListingAvailabilityInput = {
  isRehomed: boolean | null;
  isReserved: boolean;
  isAvailableNow: boolean | null;
  availableDate: string | null;
};

export const formatListingAvailabilityStatus = (
  item: ListingAvailabilityInput,
  now: Date = new Date()
): ListingAvailabilityStatus => {
  if (item.isRehomed || item.isReserved) {
    return { label: 'Reserved', variant: 'grey' };
  }
  if (
    item.availableDate &&
    !isListingAvailable(item.isAvailableNow, item.availableDate, now)
  ) {
    return { label: 'Coming soon', variant: 'blue' };
  }
  return { label: 'Ready for rehoming', variant: 'green' };
};
